export default {
  title: 'Ativar MAXHUB',
  instruction: 'Por favor, preencha devidamente a informação do utilizador e revendedor que possa afetar questões relacionadas com o serviço pós-venda',
  dealername: 'Nome do revendedor',
  dealerplaceholder: 'Nome do revendedor',
  companyname: 'Nome da empresa',
  companyplaceholder: 'Nome da empresa',
  tele: 'Informação para contacto',
  teleplaceholder: 'Telemóvel',
  district: 'Selecionar área',
  distplaceholder: 'Informação da área',
  address: 'Endereço detalhado',
  addrplaceholder: 'Endereço detalhado',
  activebtn: 'Obter o código de ativação',
  confirmbtn: 'Confirmar',
  cancelbtn: 'Cancelar',
  dialogmessage: 'O formato do telemóvel está errado, por favor insira novamente',
  dialogbtn: 'Confirmar',
  errortitle: 'Não consegue abrir',
  errorinfo1: 'Tente verificar a rede',
  errorinfo2: 'Linha direta 400-168-9545',
  nosn: 'Este dispositivo não pode ser ativado visto que não tem SN',
  activepagetitle: 'Código de ativação',
  activepagehint: 'Por favor, insira o código de ativação para ativar o dispositivo',
  finish: 'Completa',
  search: 'Pesquisa por localização'
};



// WEBPACK FOOTER //
// ./src/i18n/_pt.js